/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Color_Aria_LabelInputs */

const en_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose speaker color`)
};

const fr_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir la couleur du locuteur`)
};

const de_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecherfarbe auswählen`)
};

const it_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli il colore dell'altoparlante`)
};

const ru_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите цвет динамика`)
};

const es_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija el color del altavoz`)
};

const zh_cn2_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择扬声器颜色`)
};

const ja_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーの色を選択`)
};

const hi_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर का रंग चुनें`)
};

const pt_pt2_speaker_manager_color_aria_label = /** @type {(inputs: Speaker_Manager_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha a cor da caixa de som.`)
};

/**
* | output |
* | --- |
* | "Choose speaker color" |
*
* @param {Speaker_Manager_Color_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_color_aria_label = /** @type {((inputs?: Speaker_Manager_Color_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Color_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_color_aria_label(inputs)
	if (locale === "de") return de_speaker_manager_color_aria_label(inputs)
	if (locale === "it") return it_speaker_manager_color_aria_label(inputs)
	if (locale === "ru") return ru_speaker_manager_color_aria_label(inputs)
	if (locale === "es") return es_speaker_manager_color_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_color_aria_label(inputs)
	if (locale === "ja") return ja_speaker_manager_color_aria_label(inputs)
	if (locale === "hi") return hi_speaker_manager_color_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_color_aria_label(inputs)
	return en_speaker_manager_color_aria_label(inputs)
});